/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * RocketshipIcon
 */
export default class RocketshipIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M21.699 1.02a1 1 0 01.772.742c.561 2.29.367 4.234-.63 5.78-.579.896-2.182 2.682-4.844 5.398l.004.06v5.672a3 3 0 01-.744 1.977l-.135.144-2.914 2.914c-.638.638-1.706.17-1.708-.696l.006-.11.478-4.787-.044-.135-.24.236a1 1 0 01-1.349.046l-.092-.09-.204-.224-1.439 2.031a1 1 0 01-.382.323l-.118.048-4.8 1.6a1 1 0 01-1.265-1.265l1.6-4.8a1 1 0 01.371-.5l2.082-1.475a.999.999 0 01-.153-.58.996.996 0 01.178-1.066l.148-.163-.35-.087-4.827.482c-.935.094-1.471-1.037-.807-1.702L3.208 7.88A3 3 0 015.329 7h5.665c2.284-2.42 3.857-3.987 4.737-4.715 1.6-1.326 3.62-1.74 5.968-1.265zM15 14.954c-.468.467-.959.955-1.473 1.463l.421 1.267a1 1 0 01.05.275l-.003.14-.222 2.213.934-.933a1 1 0 00.284-.576l.009-.131v-3.718zm-7.482.404l-2.074 1.469-.864 2.592 2.592-.864 1.469-2.074-1.123-1.123zm9.488-11.533c-1.22 1.01-4.057 3.944-8.462 8.758l-.325.356 2.794 3.086.031.03c5.186-5.094 8.24-8.309 9.063-9.52l.052-.077c.588-.911.766-2.093.504-3.581-1.485-.178-2.684.142-3.657.948zM9.126 8.999L5.329 9a1 1 0 00-.707.293l-.933.933 2.212-.22a1 1 0 01.342.024l1.57.392c.455-.496.893-.97 1.313-1.423z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

